<template>
  <div class="app-container">
    <div class="app_content" v-loading="loading">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="帮助" name="help_info"></el-tab-pane>
        <el-tab-pane label="协议" name="agreement_info"></el-tab-pane>
        <el-tab-pane label="商家入驻条款" name="merchant_entry_terms"></el-tab-pane>
        <el-tab-pane label="汇率" name="reate"></el-tab-pane>
      </el-tabs>
      <richText
        v-if="activeName == 'help_info' || activeName == 'agreement_info' || activeName == 'merchant_entry_terms'"
        :RichText="query.sc_value"
        @getRichText="getRichText"
      ></richText>
      <el-form v-else :model="form" label-position="left" :rules="rules" ref="form">
        <div style="display:flex;width: 100%;">
          <div style="width: 50%;">
            <el-form-item label="黄金" label-width="60px" prop="sc_value.gold">
              <div class="common">￥</div>
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.gold" />
            </el-form-item>
            <el-form-item label="白银" label-width="60px" prop="sc_value.silver">
              <div class="common">￥</div>
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.silver" />
            </el-form-item>
            <el-form-item label="铂金" label-width="60px" prop="sc_value.platinum">
              <div class="common">￥</div>
             <el-input type="number" placeholder="请输入" v-model="form.sc_value.platinum" />
            </el-form-item>
            <el-form-item label="钯金" label-width="60px" prop="sc_value.palladium">
              <div class="common">￥</div>
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.palladium" />
            </el-form-item>
          </div>
          <div style="width: 50%;margin-left: 100px;">
            <el-form-item label="美元人民币" label-width="140px" prop="sc_value.dollar">
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.dollar" />
            </el-form-item>
            <el-form-item label="离岸人民币" label-width="140px" prop="sc_value.rmb">
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.rmb" />
            </el-form-item>
            <el-form-item label="汇率浮动加点(%)" label-width="140px" prop="sc_value.rate_float">
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.rate_float" />
            </el-form-item>
            <el-form-item label="浮动金价" label-width="140px" prop="sc_value.gold_float">
              <el-input type="number" placeholder="请输入" v-model="form.sc_value.gold_float" />
            </el-form-item>
          </div>
        </div>
      </el-form>
      <el-button style="margin-top: 10px" type="primary" @click="save('form')">保存</el-button>
    </div>
  </div>
</template>

<script>
import richText from "@/components/richText/richText.vue";
import { getConfig, saveConfig, getRate, saveRate } from "@/api/api";
export default {
  components: { richText },
  data() {
    return {
      activeName: "help_info",
      query: {
        sc_key: "help_info",
        sc_value: "",
        sc_desc: "帮助",
        sc_status: 1,
      },
      loading: false,
      form: {
        sc_key: '',
        sc_value: "",
        sc_desc: '',
        sc_status: ''
      },
      rules: {
        'sc_value.gold': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.silver': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.platinum': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.palladium': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.dollar': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.rmb': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.rate_float': [{ required: true, message: '请输入', trigger: 'blur'}],
        'sc_value.gold_float': [{ required: true, message: '请输入', trigger: 'blur'}],
      }
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      getConfig({'sc_key':this.query.sc_key})
        .then((res) => {
          this.loading = false;
          this.query.sc_value = res.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getRate() {
      getRate().then((res) => {
        console.log(res,'res');
        this.form = {...res.data}
      });
    },
    getRichText(val) {
      this.query.sc_value = val;
    },
    handleClick(e) {
      this.activeName = e.name;
      this.query.sc_key = e.name;
      if (e.name == "help_info") {
        this.query.sc_desc = "帮助";
      } else if (e.name == "agreement_info") {
        this.query.sc_desc = "协议";
      }else if (e.name == "merchant_entry_terms") {
        this.query.sc_desc = "商家入驻条款";
      } else {
        this.getRate();
      }
      this.$nextTick(() => {
        this.init();
      });
    },
    save(formName) {
      if ( this.activeName == "help_info" || this.activeName == "agreement_info" || this.activeName == "merchant_entry_terms") {
        this.loading = true;
        saveConfig(this.query).then((res) => {
          this.loading = false;
          this.$message({
            message: "保存成功",
            type: "success",
          });
        });
      }else{
        this.$refs[formName].validate((valid) => {
          if(valid){
            let obj = this.form.sc_value
            for (const key in obj) {
              if (Object.hasOwnProperty.call(obj, key)) {
                const element = obj[key];
                if (element<=0) {
                  this.$message({
                    message: "输入内容需大于0",
                    type: "warning",
                  });
                  return
                }
              }
            }
            this.loading = true;
            saveRate(this.form).then(() => {
              this.loading = false;
              this.$message({
                message: "保存成功",
                type: "success",
              });
            })
          }else{
            return false
          }
        })
      }
    },
  },
};
</script>

<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>

<style lang="scss" scoped>
::v-deep .el-input--medium .el-input__inner{
  padding-left: 25px;
}
.common{
  position: absolute;
  left: 10px;
  z-index: 999;
}

</style>
